export default (state) => state.restrictionEnzymes.isEnzymeFilterAnd;
